import React, { useEffect, useState, useContext } from 'react';
import store from '../../store';
import { createUserWithEmailAndPassword } from '../../constants';
// Custom components
import AnonSignIn from '../AnonymousSignIn';
import { DefaultButton } from '../Buttons';
import { PrivacyPolicy } from '../Links';
// Material components
import {
    TextField,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography
} from '@material-ui/core';
// Styles
import { flex } from '../../assets/jss'
import { makeStyles } from '@material-ui/core/styles'
const textfield = {
    borderRadius: 8,
}
const useStyles = makeStyles((theme) => ({
    error: {
        ...textfield,
        borderBottom: 'solid 4px #ff00001a'
    },
    success: {
        ...textfield,
        borderBottom: 'solid 4px #00ff661a'
    },
    header: {
        ...flex.flex_row_between,
        alignItems: 'center'
    },
    footer: {
        ...flex.flex_row_center,
        alignItems: 'center',
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            ...flex.flex_column_center,
        }
    },
    footer2: {
        ...flex.flex_column_center
    }
}))

const initState = {
    email: '',
    password: '',
    confirm: ''
}
export default function FormDialog({ switchStatus, handleOpen }) {
    const classes = useStyles();
    const { setProfile } =useContext(store);
    const [formData, setFormData] = useState(initState);
    const [formComplete, setFormComplete] = useState(false);

    const handleformData = (key, value) => {
        setFormData({ ...formData, [key]: value })
    }
    const checkPassword = () => {
        if (formData.password.length < 8) {
            return false
        }
        return true
    }
    const checkConfirm = () => {
        if (formData.confirm !== formData.password || formData.confirm === '') {
            return false
        }
        return true
    }
    const verifyFormData = () => {
        if (formData.email !== '' && checkConfirm()) {
            setFormComplete(true);
        }
    }
    const handleSubmit = () => {
        createUserWithEmailAndPassword(formData.email, formData.password, handleOpen, setProfile);
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && formComplete) {
            handleSubmit();
        }
    }

    useEffect(() => {
        verifyFormData();
        //eslint-disable-next-line
    }, [formData])

    return (
        <React.Fragment>
            <div className={classes.header}>
                <DialogTitle>Subscribe</DialogTitle>
            </div>

            <DialogContent onKeyPress={handleKeyPress}>
                <DialogContentText>
                    To subscribe to this website, please enter a valid email address.
                </DialogContentText>

                <TextField
                    margin="dense"
                    id="email"
                    label="Email Address"
                    type="email"
                    fullWidth
                    className={formData.email === '' ? classes.error : classes.success}
                    onChange={(e) => handleformData('email', e.target.value)}
                />
                <TextField
                    margin="dense"
                    id="password"
                    label="Password"
                    type="password"
                    className={checkPassword() ? classes.success : classes.error}
                    onChange={(e) => handleformData('password', e.target.value)}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    id="password-confirm"
                    label={checkConfirm() ? 'Passwords match!' : 'Confirm your password'}
                    type="password"
                    className={checkConfirm() ? classes.success : classes.error}
                    onChange={(e) => handleformData('confirm', e.target.value)}
                    fullWidth
                />
            </DialogContent>
            <DialogContent className={classes.footer}>
                <PrivacyPolicy />
            </DialogContent>
            <DialogActions className={classes.footer}>
                <DefaultButton
                    disabled={!formComplete ? true : false}
                    onClick={handleSubmit}
                    variant='dark'>
                    Create Account
                </DefaultButton>
                <br />
                <AnonSignIn />
            </DialogActions>
            <DialogActions className={classes.footer2}>
                <Typography>
                    Already have an Account?
                </Typography>
                <br />
                <DefaultButton
                    onClick={switchStatus}
                    variant='dark'>
                    Login
                </DefaultButton>
            </DialogActions>
        </React.Fragment>
    );
}